module.exports = {
    "message.transform.isSuccess": "Is Success",
    "message.aegOutboundOrderDetail.consignColumn.inboundNo": "Logistic No.",
    "message.lzdInboundCreateView.tableColumn.estimatedTime": "Estimated Time",
    "message.CreateTransferOrder.senderCountry": "Sender Country",
    "message.menu.stockAllocation": "Channel Inventory Management",
    "message.lzdInboundPlanView.replenishColumns.sellerName": "Seller Name",
    "message.transform.downloadErrorFileUrl": "Error File Download Link",
    "message.taskCenterView.button.search": "Search",
    "message.card.fulfillment.receiverAddress": "Receiver Address",
    "message.CreateTransferOrder.addSkuBtn": "add",
    "message.card.fulfillment.warehouseName": "Warehouse Name",
    "message.views.productView.skuStatus": "SKU Status",
    "message.TransferOrder.shipped": "Shipped",
    "message.inboundView.table.createFoc": "create FOC",
    "message.login.language": "Language",
    "message.outboundView.table.orderQuantity": "Quantity",
    "message.views.inventoryLedger.orderTypeMap.INVENTORY_STATUS_ADJUST_IN": "Inventory status adjust",
    "message.lzdInboundCreateView.addSkuView.quantity": "Requested Quantity",
    "message.CreateTransferOrder.senderName": "Sender Name",
    "message.aegOutboundOrderDetail.consignColumn.creator": "Creator",
    "message.views.scItemView.productType": "Product Type",
    "message.views.inventoryAging.91-120day": "91-120 Day",
    "message.card.fulfillment.receiverCountry": "Receiver Country",
    "message.CreateTransferOrder.deliveryInfo": "Delivery Info",
    "message.menu.inventoryAging": "Inventory Aging",
    "message.views.feedback.systemRate": "System Rate",
    "message.table.fulfillment.action": "Action",
    "message.table.fulfillment.shippingType": "Shipping Type Code",
    "message.outboundView.button.exportAllOrder": "Export All Order",
    "message.views.workbench.dailyOrderQuantity": "Daily Order Quantity",
    "message.aegOutboundOrderDetail.title.supplierId": "Supplier Id",
    "message.taskCenterView.table.taskId": "Task Id",
    "message.lzdInboundPlanView.replenishColumns.destinationCode": "Warehouse",
    "message.CreateTransferOrder.senderTel": "Sender Tel",
    "message.lzdInboundCreateView.title.sellerFlag": "Seller Information",
    "message.table.fulfillment.scItemId": "Sc Item Id",
    "message.lzdInboundCreateView.title.skuFlag": "SKUS",
    "message.menu.fulfillmentOrderDetail": "Fulfillment Order Detail",
    "message.transform.record": "Recent Bound Record",
    "message.card.fulfillment.itemInfomation": "Item Infomation",
    "message.views.inventoryReconciliation.ledgerDetail": "Ledger Detail",
    "message.views.liveInventory.onWay.inBoundOnWay": "Inbound OnWay",
    "message.aegOutboundOrderDetail.consignColumn.supplierName": "Supplier Name",
    "message.CreateTransferOrder.submitBtn": "submit",
    "message.lzdInboundDetail.title.estimateTime": "Estimated Time",
    "message.views.liveInventory.commodity": "Commodity",
    "message.views.scItemView.skuId": "SKU ID",
    "message.transform.startBind": "Start Store Bind Check",
    "message.views.inventoryLedger.inventoryTypeMap.onWay": "ON WAY",
    "message.transform.orderCheck": "ICP/IO order Check",
    "message.lzdInboundCreateView.addSkuView.barcodes": "Barcodes",
    "message.TransferOrder.transfered": "Transfered",
    "message.aegInboundDetail.purchaseItemColumn.title": "Seller SKU",
    "message.views.inventoryLedger.inventoryType": "Inventory Type",
    "message.views.workbench.productSold": "Product Sold",
    "message.button.search": "Search",
    "message.menu.createNewInboundOrder": "Create New Inbound Order",
    "message.inboundView.title.fulfilmentOrderCode": "Fulfilment Order No.",
    "message.views.liveInventory.warehouseCode": "Warehouse Code",
    "message.inboundView.table.expiredTime": "Expired Time",
    "message.views.inventoryLedger.inventoryTypeMap.defective": "DEFECTIVE",
    "message.aegOutboundOrderDetail.title.remark": "Remark",
    "message.views.workbench.dashboardDescription.inventoryTurnOver": "Inventory turnover: sales volume / average inventory in the last month",
    "message.lzdOutboundViewDetail.title.logisticLogs": "Logistic Log",
    "message.views.stockAllocation.scItemId": "ScItemId",
    "message.card.fulfillment.promiseEarliestDate": "Promise Earliest Date",
    "message.views.inventoryReconciliation.changeTypeMap.totalOtherOutbounded": "Other Outbounded",
    "message.views.workbench.wow": "Weekly Ratio",
    "message.lzdInboundDetail.title.mobile": "Mobile",
    "message.menu.productView": "Product",
    "message.CreateTransferOrder.destSellerSKU": "Dest Seller SKU",
    "message.lzdOutboundViewDetail.title.userNick": "User Nick",
    "message.inboundView.table.skuQuantity": "Quantity",
    "message.views.workbench.productSoldTendency": "Product Sold Tendency",
    "message.lzdInboundPlanView.queryForm.scItemCode": "Fulfilment SKU",
    "message.aegInboundDetail.title.storeCode": "Store Code",
    "message.views.liveInventory.seller": "Seller",
    "message.views.productView.barcode": "Barcodes",
    "message.outboundView.table.platform": "Platform",
    "message.transform.shopBindFailed": "Store Binding Failed",
    "message.lzdInboundCreateView.addSkuView.resetBtn": "Reset",
    "message.outboundView.table.merchantCode": "Merchant Code",
    "message.lzdInboundPlanView.replenishColumns.operate": "Operate",
    "message.views.stockAllocation.ruleAllocation": "Adjust Rule",
    "message.views.scItemView.upShelf": "Up Shelf",
    "message.aegInboundDetail.btn.detail": "Detail",
    "message.form.fulfillment.plName": "Delivery Provider",
    "message.TransferOrder.inboundWarehouse": "Inbound Warehouse",
    "message.views.productPublishView.batchPublish": "Batch Publish",
    "message.lzdInboundCreateView.tableColumn.contactInfo": "Contact",
    "message.outboundView.table.supplier": "Supplier",
    "message.aegInboundDetail.title.batchInformation": "Batch Information",
    "message.CreateTransferOrder.receiverInfo": "Receiver Info",
    "message.TransferOrder.detail": "Detail",
    "message.taskCenterView.table.taskName": "Task Name",
    "message.card.fulfillment.receiverProvince": "Receiver Province",
    "message.aegInboundDetail.title.creator": "Creator",
    "message.aegInboundDetail.title.logisticLogs": "Logistic Logs",
    "message.lzdInboundCreateView.tableColumn.sellerPostcode": "Post Code",
    "message.transform.bindCheckSuccess": "Inventory Binding Check Succeeded",
    "message.views.inventoryReconciliation.stockChange": "Stock Movement",
    "message.aegInboundDetail.logisticColumn.fulfillStatusDesc": "Fulfil Status Desc",
    "message.views.activityInventory.scItemId": "ScItemId",
    "message.aegOutboundOrderDetail.title.batchInformation": "Batch Information",
    "message.lzdInboundDetail.lzdItemTable.itemCompleted": "Item Completed",
    "message.views.stockAllocation.outChannel": "Out Channel",
    "message.CreateTransferOrder.skuView.crossMerchantSku": "cross merchant sku",
    "message.outboundView.table.inventoryType": "Inventory Type",
    "message.lzdInboundDetail.lzdItemTable.scItemCode": "Item Code",
    "message.views.productView.platformSkuDetail": "SKU Detail",
    "message.views.productPublishView.upload": "UpLoad",
    "message.form.fulfillment.deliveryType": "Delivery Confirm",
    "message.views.productView.platformTitle": "Title",
    "message.aegOutboundOrderDetail.purchaseItemColumn.remark": "Remark",
    "message.menu.demoDashboard": "Dashboard Demo",
    "message.transform.shopBindingWaitingMention": "Store binding is expected to take a few minutes, please do not close the current page.",
    "message.menu.cbFulfillmentOrder": "Cross-border Order",
    "message.table.fulfillment.reverseTradeOrderId": "Reverse Trade Order Id",
    "message.views.scItemView.mainShop": "MainShop",
    "message.button.printPdf": "Print Pdf",
    "message.lzdInboundDetail.title.deliverType": "Deliver Type",
    "message.message.fulfillment.shippingSuccess": "Shipping success!",
    "message.outboundView.table.operate": "Operate",
    "message.lzdInboundDetail.lzdItemTable.scItemName": "Item Name",
    "message.aegInboundDetail.goodsTable.barcode": "Barcode",
    "message.button.export": "Export",
    "message.table.fulfillment.orderStatusDesc": "Order Status",
    "message.views.productPublishView.atLeastOneImage": "At least one image required",
    "message.table.fulfillment.itemName": "Item Name",
    "message.views.productView.platformSku": "PlatformSku",
    "message.common.detail": "Detail",
    "message.inboundView.button.createOutboundBtn": "Create New Oo",
    "message.transform.success": "Success",
    "message.lzdInboundCreateView.addSkuView.addSkuTitle": "Add Sku",
    "message.transform.startShopBind": "Start Store Binding",
    "message.views.scItemView.deleteRelatedPlatformSku": "Delete related item",
    "message.CreateTransferOrder.skuView.search": "search",
    "message.views.feedback.feedbackType": "Problem Type",
    "message.lzdInboundDetail.title.shop": "Shop",
    "message.views.inventoryLedger.orderTypeMap.PURCHASE_IN": "Seller/Supplier Inbound",
    "message.views.productPublishView.plsSelectTheCategory": "Please select the category",
    "message.menu.feedback.dashboardScore": "Dashboard Score",
    "message.views.scItemView.sureDelete": "sure to delete?",
    "message.views.inventoryLedger.orderTypeMap.INVENTORY_STATUS_ADJUST_OUT": "Inventory status adjust",
    "message.views.publishTemplateView.shortDesc": "Short Description",
    "message.views.scItemView.downShelf": "Down Shelf",
    "message.transform.shopBindException": "Store Binding Exception",
    "message.menu.createNewOutboundOrder": "Create New Outbound Order",
    "message.card.fulfillment.receiverMobile": "Receiver Mobile",
    "message.CreateTransferOrder.skuView.quantity": "Transfer quantity",
    "message.views.stockAllocation.fulfillmentSkuName": "Fulfillment Sku Name",
    "message.card.fulfillment.fulfillmentOrderInformation": "Fulfillment Order Information",
    "message.views.inventoryReconciliation.changeTypeMap.totalLost": "Lost",
    "message.card.fulfillment.receiverName": "Receiver Name",
    "message.views.inventoryAging.platform": "Platform",
    "message.views.productView.price": "Price",
    "message.views.dashboardScore.dashboardName.all_authorized_shop": "All Authorized Shop",
    "message.views.workbench.toReplenishment": "To Replenishment",
    "message.views.productView.gmtModified": "Modify Time",
    "message.views.inventoryAging.121-150day": "121-150 Day",
    "message.views.productView.sellerSku": "Seller SKU",
    "message.outboundView.button.exportBtn": "Export",
    "message.lzdInboundDetail.lzdItemTable.itemRequested": "Item Requested",
    "message.views.dashboardScore.dashboardName.to_deliver": "To Deliver",
    "message.views.inventoryLedger.orderTypeMap.CHECK_OUT": "Cycle Count Loss",
    "message.form.fulfillment.tradeOrderId": "Trade Order Id",
    "message.TransferOrder.outboundOrderNO": "Outbound Order NO",
    "message.views.workbench.gmv": "GMV",
    "message.aegInboundDetail.title.purchaseOrderCode": "Purchase Order Code",
    "message.table.fulfillment.warehouseCode": "Warehouse Code",
    "message.aegInboundDetail.purchaseItemColumn.measureUnit": "Measure Unit",
    "message.CreateTransferOrder.senderPostCode": "Sender PostCode",
    "message.views.stockAllocation.adjustRuleSuccess": "Adjust Rule Success",
    "message.lzdInboundDetail.title.purchaseOrderCode": "Purchase Order No",
    "message.select.fulfillment.deliverySuccess": "Delivery Success",
    "message.inboundView.button.importBtn": "Import",
    "message.views.workbench.totalItemSold": "Total Item Sold",
    "message.CreateTransferOrder.senderAddress": "Sender Address",
    "message.inboundView.table.detail": "Detail",
    "message.aegOutboundOrderDetail.purchaseItemColumn.returnQtyDec": "Return Quantity",
    "message.transform.errorFile": "Error File",
    "message.menu.fulfillmentPackage": "Fulfillment Package",
    "message.views.scItemView.brand": "Brand",
    "message.CreateTransferOrder.receiverAddress": "Receiver Address",
    "message.transform.lzd.description": "Lazada Store Binding Entrance",
    "message.views.inventoryAging.61-90day": "61-90 Day",
    "message.drawer.fulfillment.trackingNumbers": "Tracking Numbers",
    "message.views.inventoryLedger.operateTime": "Operation Time",
    "message.transform.shopBindSuccess": "Store Binding Successfully",
    "message.CreateTransferOrder.skuView.platformSku": "Platform SKU",
    "message.views.productView.itemSite": "Site",
    "message.aegInboundDetail.logisticColumns.bizOrderNo": "Flow Number",
    "message.views.workbench.gmvRank": "GMV Ranking",
    "message.views.liveInventory.sellableOccupy": "Reserved Sellable",
    "message.transform.selectShop": "Select Store",
    "message.transform.InventoryBinding": "Inventory Binding",
    "message.lzdInboundCreateView.tableColumn.sellerCity": "Seller City",
    "message.views.workbench.operation": "Operation",
    "message.views.productPublishView.skuImage": "Sku Images",
    "message.aegOutboundOrderDetail.purchaseItemColumn.brandName": "Brand Name",
    "message.views.activityInventory.campaignName": "Campaign Name",
    "message.aegInboundDetail.title.expiredTime": "Expired Time",
    "message.CreateTransferOrder.destPlatform": "Dest Platform",
    "message.inboundView.table.supplier": "Supplier",
    "message.views.dashboardScore.table.dashboardName": "Dashboard Name",
    "message.outboundView.title.fulfilmentOrderCode": "Fulfilment Order No.",
    "message.taskCenterView.table.downLoad": "DownLoad",
    "message.views.inventoryLedger.orderCode": "Order Code",
    "message.aegInboundDetail.logisticColumns.fulfillStatus": "Status",
    "message.views.workbench.authorizationShop": "Authorized Shop",
    "message.views.inventoryAging.31-60day": "31-60 Day",
    "message.views.stockAllocation.edit": "edit",
    "message.views.scItemView.fileExport": "Export",
    "message.views.scItemView.reload": "Clear Selections",
    "message.transform.bindCheckFailed": "Inventory Binding Check Failed",
    "message.views.workbench.merchantCode": "merchant",
    "message.transform.operateStore": "Operate Store",
    "message.views.workbench.orderQuantityTendency": "Order Quantity Tendency",
    "message.views.workbench.shopGmvProportion": "Proportion Of GMV",
    "message.table.fulfillment.cbOrderStatus": "CB Order Status Code",
    "message.views.workbench.orderQuantityRank": "Order Quantity Ranking",
    "message.lzdInboundCreateView.title.basicFlag": "Basic Information",
    "message.views.inventoryLedger.orderTypeMap.OTHER_INBOUND": "Customer Return Inbound",
    "message.views.productView.skuStock": "SKU Stock",
    "message.aegInboundDetail.goodsTable.normalQtyDec": "Normal Qty.",
    "message.aegOutboundOrderDetail.title.merchantName": "Merchant Name",
    "message.views.productPublishView.category": "Category",
    "message.views.scItemView.itemCode": "ItemCodes",
    "message.inboundView.table.cancel": "Cancel",
    "message.login.switch_to_zh_cn": "切换为中文",
    "message.inboundView.button.LzdTemplate": "Lazada",
    "message.transform.waitingMention": "Inventory binding is expected to take a few minutes, please do not close the current page.",
    "message.table.fulfillment.shippingTypeDesc": "Shipping Type",
    "message.CreateTransferOrder.sellerSKU": "Source Seller SKU",
    "message.form.fulfillment.warehouseCode": "Warehouse Code",
    "message.menu.inventoryLedger": "Inventory Ledger",
    "message.table.fulfillment.merchantCode": "Merchant",
    "message.TransferOrder.inventoryType": "Inventory Type",
    "message.menu.feedback.feedbackName": "Feedback",
    "message.views.inventoryAging.skuVolumn": "SKU  Volumn",
    "message.aegInboundDetail.title.cancelPerson": "Cancel Person",
    "message.lzdInboundDetail.lzdItemTable.orderItemStatus": "Item Status",
    "message.lzdOutboundViewDetail.title.orderStatus": "Order Status",
    "message.views.activityInventory.activeTime": "Active Time",
    "message.views.productPublishView.mainImage": "Main images",
    "message.views.workbench.dailyItemSold": "Daily Item Sold",
    "message.TransferOrder.transferOrderNo": "Transfer Order NO",
    "message.form.fulfillment.siteList": "Site",
    "message.menu.ownerTransfer.title": "OwnerTransfer",
    "message.menu.gfc.title": "Enter GFC",
    "message.views.productPublishView.pleaseChooseTheShop": "Please choose the shop",
    "message.taskCenterView.title.source": "Source",
    "message.aegInboundDetail.title.warehouseAddress": "Address",
    "message.outboundView.button.search": "Search",
    "message.views.inventoryLedger.orderTypeMap.B2B_PURCHASE_IN": "Failed Delivery Inbound",
    "message.table.fulfillment.itemQuantity": "Item Quantity",
    "message.views.workbench.thisMonth": "This Month",
    "message.views.workbench.thisWeek": "This Week",
    "message.views.stockAllocation.fulfillmentSkuCode": "Fulfillment Sku Code",
    "message.menu.transferOrder": "Transfer Order",
    "message.menu.inboundPlanItem": "Replenishment",
    "message.views.stockAllocation.cancel": "cancel",
    "message.table.fulfillment.receiverAddress": "Receiver Address",
    "message.aegInboundDetail.logisticColumn.bizOrderNo": "Biz Order No",
    "message.CreateTransferOrder.skuView.inventoryType": "inventory type",
    "message.inboundView.title.orderStatus": "Status",
    "message.aegInboundDetail.title.channel": "Channel",
    "message.views.productPublishView.submit": "Submit",
    "message.views.stockAllocation.search": "Search",
    "message.lzdInboundCreateView.addSkuView.platformSku": "Platform Sku",
    "message.outboundView.button.template": "Template",
    "message.views.inventoryReconciliation.changeTypeMap.totalShipped": "Shipped to Customers",
    "message.views.inventoryReconciliation.changeTypeMap.totalReturnToSeller": "Seller Outbounded",
    "message.aegOutboundOrderDetail.title.logisticOrderCode": "Logistic Order Code",
    "message.views.productPublishView.pleaseSelectTheCategory": "Please select the category",
    "message.login.switch_to_another_language": "切换为中文",
    "message.lzdInboundCreateView.addSkuView.serialNumber": "Serial Number",
    "message.views.inventoryLedger.inventoryTypeMap.transferOnWay": "TRANSFER ON WAY",
    "message.transform.isDone": "Whether or not complete",
    "message.aegOutboundOrderDetail.purchaseItemColumn.scItemId": "Item Id",
    "message.card.fulfillment.deliveryInfomation": "Delivery Information",
    "message.taskCenterView.title.taskStatus": "TaskStatus",
    "message.views.dashboardScore.dashboardName.all_product_sold": "Total Product Sold",
    "message.card.fulfillment.receiverCity": "Receiver City",
    "message.aegInboundDetail.logisticColumn.operateTime": "Operate Time",
    "message.views.productView.showRelation": "Show Relation",
    "message.views.workbench.suggestToReplenish": "Suggest to Replenish",
    "message.TransferOrder.create": "Create",
    "message.form.fulfillment.inputTrackingNumber": "Please input tracking numbers!",
    "message.table.fulfillment.orderItemStatusDesc": "Order Item Status",
    "message.views.stockAllocation.allLessThan100": "all ratio are not allowed less than 100 ,please adjust.",
    "message.lzdInboundCreateView.tableColumn.warehouse": "Warehouse",
    "message.inboundView.title.platform": "Platform",
    "message.CreateTransferOrder.receiverTel": "Receiver Tel",
    "message.views.workbench.mom": "MOM",
    "message.views.productView.fulfillmentSku": "FulfillmentSku",
    "message.transform.bindCheckException": "Inventory Binding Check Is Exception",
    "message.CreateTransferOrder.operate": "Operate",
    "message.CreateTransferOrder.fulfillmentSKU": "Source Fulfillment SKU",
    "message.views.stockAllocation.ratio": "ratio",
    "message.transform.cancel": "Cancel",
    "message.views.inventoryLedger.orderTypeMap.ADJUST_IN": "Adjust in",
    "message.transform.secondStep": "Second Step",
    "message.transform.startInventoryBind": "Start Inventory Bind",
    "message.CreateTransferOrder.skuView.reset": "reset",
    "message.transform.check": "Inventory Binding Check",
    "message.outboundView.table.receivedQuantity": "Received Quantity",
    "message.lzdInboundCreateView.addSkuView.shelfLife": "Shelf Life",
    "message.lzdInboundDetail.lzdItemTable.goodsBarcode": "Good Barcodes",
    "message.modal.pdfContext": "Go to print or download",
    "message.inboundView.alert.cancel": "Cancel",
    "message.views.scItemView.bindRelatedPlatformSku": "Bind related item",
    "message.button.helpCenter": "Help Center",
    "message.lzdInboundCreateView.addSkuView.goodQuantity": "Good Quantity",
    "message.table.fulfillment.itemDiscountFee": "Item Discount Fee",
    "message.views.workbench.toDeliver": "To Deliver",
    "message.taskCenterView.table.creator": "Creator",
    "message.lzdOutboundViewDetail.title.sellerAddress": "Seller Address",
    "message.views.inventoryLedger.orderTypeMap.COORDINATE_IN": "Stock Transfer Inbound",
    "message.form.fulfillment.cbFulfillmentOrderId": "Cb Fulfillment Order Id",
    "message.views.productPublishView.import": "Import",
    "message.lzdInboundPlanView.queryForm.replenishment": "Replenish",
    "message.TransferOrder.status": "Status",
    "message.TransferOrder.toMerchant": "dest merchant",
    "message.views.workbench.all": "All",
    "message.CreateTransferOrder.skuView.SKU": "sku",
    "message.views.liveInventory.code": "Code",
    "message.card.fulfillment.fulfillmentOrderItemId": "Fulfillment Order Item Id",
    "message.outboundView.table.warehouse": "Warehouse",
    "message.lzdInboundDetail.title.warehouseName": "Warehouse",
    "message.CreateTransferOrder.receiverName": "Receiver Name",
    "message.lzdInboundCreateView.title.sellerAddress": "Seller Address",
    "message.lzdInboundPlanView.replenishColumns.replQuantity": "Repl Quantity",
    "message.table.fulfillment.siteId": "Site Id",
    "message.aegOutboundOrderDetail.consignColumn.formatPreArriveTime": "Pre Arrived Time",
    "message.transform.authStore": "Authorized Store",
    "message.views.scItemView.skuStatus": "SKU Status",
    "message.lzdOutboundViewDetail.title.SKU": "SKU",
    "message.transform.bindSuccess": "Inventory Binding Successfully",
    "message.transform.shopList": "Bound Store List",
    "message.lzdInboundPlanView.queryForm.warehouse": "Warehouse",
    "message.card.fulfillment.orderStatus": "Order Status",
    "message.aegInboundDetail.goodsTable.defectiveQtyDec": "Defective Qty.",
    "message.select.fulfillment.partialShipping": "Partial Shipping",
    "message.common.input": "Input please",
    "message.views.workbench.fulfillmentOrderItemId": "Fulfillment Order Item Id",
    "message.CreateTransferOrder.estimatedOutboundTime": "Estimated outbound time",
    "message.TransferOrder.exportBtn": "Export",
    "message.lzdOutboundViewDetail.title.warehouseName": "Warehouse",
    "message.CreateTransferOrder.senderInfo": "Sender Info",
    "message.views.inventoryAging.150-180day": "150-180 Day",
    "message.form.fulfillment.merchantList": "Merchant",
    "message.card.fulfillment.warehouseCode": "Warehouse Code",
    "message.TransferOrder.merchant": "merchant",
    "message.transform.startCheck": "Start Inventory Binding Check",
    "message.views.scItemView.category": "Category",
    "message.views.dashboardScore.table.comment": "Comment",
    "message.inboundView.button.createInboundBtn": "Create New Io",
    "message.card.fulfillment.buyerId": "Buyer Id",
    "message.views.inventoryLedger.changeQuantity": "Change Quantity",
    "message.card.fulfillment.promiseLatestDate": "Promise Latest Date",
    "message.CreateTransferOrder.receiverCountry": "Receiver Country",
    "message.login.switch_to_vi_vn": "Chuyển sang tiếng Việt",
    "message.views.dashboardScore.dashboardName.proportion_of_shop_product_sold": "Proportion Of Shop Product Sold",
    "message.CreateTransferOrder.deliverType": "Delivery Type",
    "message.table.fulfillment.orderStatus": "Order Status Code",
    "message.inboundView.button.template": "Template",
    "message.views.liveInventory.warehouseName": "Warehouse Name",
    "message.views.scItemView.fulfillmentTitle": "FulfillmentSku Title",
    "message.views.workbench.warehouse": "Warehouse",
    "message.table.fulfillment.itemId": "Item Id",
    "message.taskCenterView.button.reset": "Reset",
    "message.aegOutboundOrderDetail.title.storeName": "Store Name",
    "message.menu.authorization.title": "Authorization",
    "message.views.liveInventory.occupy": "Lock",
    "message.inboundView.table.orderQuantity": "Order Quantity",
    "message.views.scItemView.logisticsAttributes": "Logistics Attributes",
    "message.views.productPublishView.clickDownloadPublishTemplate": "Download the Publish Template",
    "message.views.productPublishView.brand": "Brand",
    "message.lzdInboundCreateView.addSkuView.operate": "Operate",
    "message.menu.shipConfirm": "Ship Confirm",
    "message.drawer.fulfillment.ship": "ship",
    "message.button.save": "Save",
    "message.views.workbench.totalProductSold": "Total Product Sold",
    "message.menu.workbench": "Workbench",
    "message.drawer.fulfillment.shippingName": "Shipping Name",
    "message.table.fulfillment.buyerId": "Buyer Id",
    "message.transform.failed": "Failed",
    "message.table.fulfillment.receiverMobile": "Receiver Mobile",
    "message.views.activityInventory.expireTime": "Expire Time",
    "message.inboundView.table.creator": "Creator",
    "message.CreateTransferOrder.estimatedInboundTime": "Estimated inbound time",
    "message.CreateTransferOrder.skuView.stock": "stock",
    "message.views.activityInventory.channelCode": "Channel Code",
    "message.views.productView.status": "Status",
    "message.views.dashboardScore.dashboardName.effect_of_operation_activity": "Effect Of Operation Activity",
    "message.table.fulfillment.sellerId": "Seller Id",
    "message.views.inventoryReconciliation.changeTypeMap.totalSellerInboundedStock": "Seller Inbounded",
    "message.transform.boundShop": "Bind Store",
    "message.views.workbench.dailyProductSold": "Daily Product Sold",
    "message.message.fulfillment.deliveryConfirm": "Delivery confirmed!",
    "message.transform.recentBindInventoryRecord": "Recent Inventory Binding Result",
    "message.lzdInboundCreateView.tableColumn.sellerCountry": "Seller Country",
    "message.drawer.fulfillment.deliverySuccess": "Delivery Success",
    "message.views.publishTemplateView.submit": "Submit",
    "message.table.fulfillment.tradeOrderId": "Trade Order Id",
    "message.inboundView.alert.sure": "Confirm",
    "message.common.fulfillment.ship": "ship",
    "message.taskCenterView.title.createdTime": "Created Time",
    "message.aegOutboundOrderDetail.purchaseItemColumn.barcode": "BareCode",
    "message.views.productView.itemId": "Item ID",
    "message.aegOutboundOrderDetail.title.storeCode": "Store Code",
    "message.views.workbench.dod": "Daily Ratio",
    "message.card.fulfillment.shipperId": "Order Owner Id",
    "message.table.fulfillment.totalFee": "Total Fee",
    "message.table.fulfillment.unitPrice": "Unit Price",
    "message.views.scItemView.platformTitle": "PlatformSku Title",
    "message.views.stockAllocation.allMoreThan100": "all ratio are not allowed more than 100, please adjust.",
    "message.aegOutboundOrderDetail.logisticColumns.fulfillStatusDesc": "Fulfil Status Desc",
    "message.views.inventoryLedger.orderTypeMap.OUTBOUND": "Seller/Supplier Outbound",
    "message.views.scItemView.width": "Width",
    "message.inboundView.table.planQuantity": "Plan Quantity",
    "message.table.fulfillment.fulfillmentOrderItemId": "Fulfillment Order Item Id",
    "message.table.fulfillment.receiverCity": "Receiver City",
    "message.views.scItemView.gmtModified": "Modify Time",
    "message.views.workbench.ito": "Inventory Turn Over",
    "message.menu.liveInventory": "Live Inventory",
    "message.aegInboundDetail.purchaseItemColumn.sentQty": "Sent Qty.",
    "message.taskCenterView.table.operate": "Operate",
    "message.views.workbench.activityResult": "Activity Result",
    "message.lzdInboundCreateView.addSkuView.fulfilmentSku": "Fulfilment Sku",
    "message.lzdInboundCreateView.tableColumn.inboundType": "Inbound Type",
    "message.views.scItemView.status": "Status",
    "message.outboundView.title.returnReason": "Return Reason",
    "message.views.productPublishView.plsSelectThePublishShop": "Please select the publish shop",
    "message.common.select": "Select please",
    "message.lzdInboundCreateView.addSkuView.queryView.platformSku": "Platform Sku",
    "message.views.liveInventory.name": "Name",
    "message.inboundView.button.search": "Search",
    "message.aegInboundDetail.title.createTime": "Created Time",
    "message.transform.startShopBindCheck": "Start Store Binding Check",
    "message.aegOutboundOrderDetail.title.orderStatus": "Order Status",
    "message.button.setting": "Setting",
    "message.views.productView.fulfillmentTitle": "FulfillmentSku Title",
    "message.TransferOrder.platform": "platform",
    "message.lzdOutboundViewDetail.title.sellerName": "Seller Name",
    "message.lzdInboundDetail.title.basicInformation": "Basic Information",
    "message.lzdInboundCreateView.tableColumn.addBtn": "Add",
    "message.views.productView.scItemMerchant": "FulfillmentSku Merchant",
    "message.views.workbench.shopItemSoldData": "Proportion Of Item Sold",
    "message.table.fulfillment.scItemName": "Sc Item Name",
    "message.views.activityInventory.platformSkuCode": "Platform Sku Code",
    "message.modal.pdfTitle": "Pdf generated successfully",
    "message.views.feedback.feedbackOptions.productSuggestion": "Product Suggestion",
    "message.transform.mentionInfo": "Inventory binding is expected to take a few minutes. Do not close the current page",
    "message.views.workbench.shopName": "Shop Name",
    "message.outboundView.table.createTime": "Created Time",
    "message.views.workbench.shopOrderQuantityData": "Proportion Of Order quantity",
    "message.views.workbench.dashboardDescription.totalOrderQuantity": "All Item Sold：Sum of all warehouse orders, Weekly Ratio: (order quantity of this week - order quantity of this week of last year) / order quantity of this week of last year, Daily Ratio (order quantity of today - order quantity of today of last year) / order quantity of today of last year, day order quantity: sum of orders of today",
    "message.outboundView.button.AegTemplate": "Ae Template",
    "message.views.workbench.dashboardDescription.totalProductSoldQuantity": "Total Product Sold: the total quantity of goods in all warehouse issued orders. Dashboard content: product sales volume data in the last seven days. Daily Product Sold: the total quantity of goods in all warehouse issued orders today",
    "message.aegInboundDetail.purchaseItemColumn.scItemId": "Fulfilment SKU",
    "message.transform.downStep": "Next step",
    "message.card.fulfillment.receiverPhone": "Receiver Phone",
    "message.lzdInboundDetail.title.inboundOrderCode": "Inbound Order No",
    "message.table.fulfillment.receiverCountry": "Receiver Country",
    "message.form.fulfillment.fulfillmentOrderId": "Fulfillment Order Id",
    "message.views.publishTemplateView.gmtCreate": "Create Time",
    "message.lzdOutboundViewDetail.title.inLbxOrderCode": "Fulfilment Order No.",
    "message.views.dashboardScore.dashboardName.monthly_product_sold_and_item_ranking": "Monthly Product Sold And Item Ranking",
    "message.menu.inOutBound": "InBound And Outbound",
    "message.inboundView.table.expectedTime": "Expected Time",
    "message.views.stockAllocation.submit": "submit",
    "message.views.scItemView.manufacturePackageDimensions": "Manufacture Package Dimensions",
    "message.views.scItemView.fulfillmentSkuDetail": "FulfillmentSku Detail",
    "message.menu.gfc.enter": "Enter GFC",
    "message.views.workbench.allShop": "All Shop",
    "message.button.reset": "Reset",
    "message.views.inventoryAging.fulfillmentSkuCode": "Fulfillment Sku Code",
    "message.views.scItemView.sureBind": "sure to bind?",
    "message.outboundView.button.importBtn": "Import",
    "message.views.productView.searchButton": "Search",
    "message.CreateTransferOrder.basicInfo": "Basic Info",
    "message.CreateTransferOrder.platform": "Source Platform",
    "message.views.stockAllocation.inChannel": "In Channel",
    "message.transform.selectStoresToBindInventory": "Select Stores To Bind Inventory",
    "message.lzdInboundDetail.title.sellerName": "Seller Name",
    "message.inboundView.button.AegTemplate": "Ae Global",
    "message.lzdInboundPlanView.replenishColumns.gmtCreate": "Created Time",
    "message.views.stockAllocation.adjustRuleFailed": "Adjust Rule Failed",
    "message.aegInboundDetail.logisticColumns.fulfillStatusDesc": "Status description",
    "message.menu.outboundItem": "Outbound",
    "message.menu.dashboard": "Dashboard",
    "message.outboundView.title.createTime": "Created Time",
    "message.aegOutboundOrderDetail.title.returnOrderNO": "Return Order No.",
    "message.inboundView.button.exportSelectedOrder": "Export Selected Order",
    "message.table.fulfillment.tradePayTime": "Trade Pay Time",
    "message.lzdInboundCreateView.tableColumn.contactPerson": "Contact Name",
    "message.TransferOrder.shopName": "Shop Name",
    "message.views.workbench.productSoldRank": "Product Sold Ranking",
    "message.CreateTransferOrder.skuView.cancel": "cancel",
    "message.views.inventoryLedger.resultQuantity": "Result Quantity",
    "message.TransferOrder.pleaseInput": "Please input",
    "message.menu.inboundItemName": "InBound",
    "message.CreateTransferOrder.skuView.sellerSku": "Seller SKU",
    "message.views.scItemView.platformSku": "PlatformSku",
    "message.views.activityInventory.site": "Site",
    "message.transform.shopBind": "Store Bind",
    "message.views.inventoryReconciliation.startDateStock": "Start Date Stock",
    "message.aegInboundDetail.title.expectedTime": "Expected Time",
    "message.views.scItemView.searchButton": "Search",
    "message.views.inventoryLedger.orderTypeMap.COORDINATE_OUT": "Stock Transfer Outbound",
    "message.inboundView.button.exportBtn": "Export",
    "message.login.switch_to_en_us": "Switch To English",
    "message.outboundView.table.outboundReason": "Outbound Reason",
    "message.views.inventoryLedger.orderTypeMap.CHECK_IN": "Cycle Count Gain",
    "message.lzdInboundCreateView.tableColumn.deleteBtn": "Delete",
    "message.transform.unfinished": "Unfinished",
    "message.CreateTransferOrder.destEntityCode": "Dest Warehouse",
    "message.button.submit": "Submit",
    "message.outboundView.button.reset": "Reset",
    "message.lzdInboundCreateView.addSkuView.queryView.sellerSku": "Seller Sku",
    "message.views.scItemView.platformSkuDetail": "PlatformSku Detail",
    "message.views.productView.brand": "Brand",
    "message.views.productPublishView.plsChooseTemplateToPublish": "You can select a template to publish",
    "message.views.activityInventory.search": "Search",
    "message.table.fulfillment.actualPaidFee": "Actual Paid Fee",
    "message.views.inventoryAging.fulfillmentSkuName": "Fulfillment Sku Name",
    "message.aegOutboundOrderDetail.purchaseItemColumn.quantityDec": "Quantity",
    "message.aegInboundDetail.logisticColumns.operator": "Operator",
    "message.aegInboundDetail.title.cancelTime": "Cancelled Time",
    "message.table.fulfillment.sellerSku": "Seller Sku",
    "message.inboundView.table.createTime": "Created Time",
    "message.views.stockAllocation.channelLock": "Channel Lock",
    "message.outboundView.title.orderStatus": "Order Status",
    "message.views.scItemView.operation": "Operation",
    "message.views.workbench.cargo": "Cargo",
    "message.inboundView.table.receivedQuantity": "Received Quantity",
    "message.transform.stockBindStore": "Stock Bound Store",
    "message.form.fulfillment.shippingTypeDesc": "Shipping Type",
    "message.form.fulfillment.reverseTradeOrderId": "Reverse Order Id",
    "message.lzdInboundCreateView.addSkuView.sellerSku": "Seller Sku",
    "message.transform.shipperCheck": "Shipper Check",
    "message.outboundView.button.LzdTemplate": "Lazada Template",
    "message.views.liveInventory.shopName": "Shop Name",
    "message.menu.scItemView": "Goods",
    "message.login.log_out": "Log Out",
    "message.views.workbench.toInbound": "To Inbound",
    "message.views.inventoryAging.greate180day": "More Than 180 Day",
    "message.aegInboundDetail.purchaseItemColumn.receivedDefectiveQtyDec": "Received Defective Qty",
    "message.form.fulfillment.inputShippingName": "Please input shipping name!",
    "message.views.publishTemplateView.search": "Search",
    "message.views.workbench.orderQuantity": "Order Quantity",
    "message.views.workbench.inboundOrderNo": "Inbound Order Code",
    "message.outboundView.table.skuQuantity": "Quantity",
    "message.table.fulfillment.sellerName": "Seller Name",
    "message.views.stockAllocation.totalInventory": "Total Inventory",
    "message.views.stockAllocation.channelName": "Channel Name",
    "message.menu.inboundPlanItemDetail": "Details of replenishment plan",
    "message.CreateTransferOrder.receiverPostCode": "Receiver PostCode",
    "message.views.workbench.thisQuarter": "This Quarter",
    "message.outboundView.table.cancel": "Cancel",
    "message.views.dashboardScore.dashboardName.channel_product_sold": "Channel Product Sold",
    "message.views.liveInventory.cargo": "Cargo",
    "message.views.publishTemplateView.operator": "Operator",
    "message.TransferOrder.requested": "Requested",
    "message.views.productPublishView.publishShop": "Publish Shop",
    "message.views.inventoryReconciliation.dateRange": "Date Range",
    "message.taskCenterView.table.gmtCreated": "Created Time",
    "message.table.fulfillment.warehouseName": "Warehouse Name",
    "message.card.fulfillment.shippingServiceCode": "Shipping Service Code",
    "message.views.workbench.totalOrderQuantity": "Total Order Quantity",
    "message.views.workbench.fulfillmentOrderId": "Fulfillment Order Id",
    "message.inboundView.alert.title": "Are you sure to cancel?",
    "message.table.fulfillment.tradeOrderItemId": "Trade Order Item Id",
    "message.views.liveInventory.unSellable": "Unsellable",
    "message.TransferOrder.inboundOrderNO": "Inbound Order NO",
    "message.views.stockAllocation.adjustStockFailed": "Adjust Stock Failed",
    "message.TransferOrder.variance": "Variance",
    "message.views.scItemView.serialNumberManagement": "Serial Number Management",
    "message.aegInboundDetail.logisticColumn.fulfillStatus": "Fulfil Status",
    "message.aegInboundDetail.title.orderStatus": "Order Status",
    "message.views.scItemView.temperatureCondition": "Temperature Condition",
    "message.common.search": "Search",
    "message.transform.bindFailedAndDownload": "Inventory Binding Failed, Download Failure Details",
    "message.views.scItemView.weight": "Weight",
    "message.table.fulfillment.receiverProvince": "Receiver Province",
    "message.lzdInboundDetail.title.warehouseAddress": "Warehouse Address",
    "message.inboundView.button.exportAllOrder": "Export All Order",
    "message.transform.auth": "Authorization",
    "message.CreateTransferOrder.skuView.barcode": "barcode",
    "message.lzdInboundDetail.lzdItemTable.scItemId": "Item Id",
    "message.inboundView.alert.selectFile": "File Selected",
    "message.views.inventoryLedger.inventoryTypeMap.good": "GOOD",
    "message.transform.failDetail": "Please view details about the failure",
    "message.views.workbench.channelItemSold": "Channel Item Sold",
    "message.views.scItemView.height": "Height",
    "message.aegInboundDetail.goodsTable.quantityDec": "Purchase Quantity",
    "message.views.inventoryReconciliation.changeTypeMap.totalOtherInboundedStock": "Other Inbounded",
    "message.table.fulfillment.orderType": "Order Type",
    "message.table.fulfillment.itemTaxActualFee": "Item Tax Actual Fee",
    "message.views.publishTemplateView.templateName": "TemplateName",
    "message.drawer.fulfillment.deliveryFailed": "Delivery Failed",
    "message.views.workbench.skuNum": "Sku Nums",
    "message.select.fulfillment.deliveryFailed": "Delivery Failed",
    "message.lzdOutboundViewDetail.title.address": "Address",
    "message.views.workbench.totalGmv": "Total Gmv",
    "message.menu.authorization.auth": "Auth",
    "message.aegOutboundOrderDetail.logisticColumns.operator": "Operator",
    "message.views.liveInventory.sellable": "Sellable",
    "message.views.liveInventory.shipper": "Shipper",
    "message.views.inventoryLedger.orderType": "Order Type",
    "message.table.fulfillment.itemShippingActualPaidFee": "Item Shipping Actual Paid Fee",
    "message.views.activityInventory.fulfillmentSkuName": "Fulfillment Sku Name",
    "message.views.scItemView.showRelation": "Show Relation",
    "message.menu.inventoryReconciliation": "Inventory Reconciliation",
    "message.table.fulfillment.receiverPhone": "Receiver Phone",
    "message.lzdOutboundViewDetail.title.outboundOrderCode": "Outbound No",
    "message.views.stockAllocation.sellableStock": "Sellable Stock",
    "message.lzdInboundDetail.title.skus": "SKU",
    "message.aegOutboundOrderDetail.logisticColumns.bizOrderNo": "Biz Order No",
    "message.views.publishTemplateView.operation": "Operation",
    "message.table.fulfillment.orderItemStatusReason": "Order Item Status Reason",
    "message.views.inventoryReconciliation.endDateStock": "End Date Stock",
    "message.button.orderExport": "Export Order",
    "message.transform.bind": "Bind",
    "message.card.fulfillment.shippingProviderName": "Shipping Provider Name",
    "message.aegOutboundOrderDetail.logisticColumns.operateTime": "Operate Time",
    "message.aegOutboundOrderDetail.title.createTime": "Created Time",
    "message.views.productView.category": "Category",
    "message.card.fulfillment.tradePayTime": "Trade Pay Time",
    "message.table.fulfillment.cbFulfillmentOrderId": "CB Fulfillment Order Id",
    "message.table.fulfillment.fulfillmentOrderId": "Fulfillment Order Id",
    "message.outboundView.button.exportSelectedOrder": "Export Selected Order",
    "message.aegInboundDetail.purchaseItemColumn.receivedNormalQty": "Received Normal Qty",
    "message.transform.toTransfer": "To Transfer",
    "message.lzdInboundCreateView.tableColumn.deliverType": "Deliver Type",
    "message.table.fulfillment.itemActualPaidFee": "Item Actual Paid Fee",
    "message.transform.itemCheck": "PlatformSku/FulfillmentSku Check",
    "message.views.stockAllocation.warehouse": "Warehouse",
    "message.menu.inventory": "Inventory",
    "message.login.switch_to_in_id": "Beralih ke bahasa Indonesia",
    "message.views.liveInventory.unSellableOccupy": "Reserved Unsellable",
    "message.taskCenterView.table.errorMsg": "Error Message",
    "message.menu.fulfillmentPackageDetail": "Fulfillment Package Detail",
    "message.outboundView.table.outboundOrder": "Outbound Order",
    "message.lzdOutboundViewDetail.title.basicInformation": "Basic Information",
    "message.aegOutboundOrderDetail.consignColumn.reserveOrderNo": "Reserve No.",
    "message.inboundView.alert.prompt": "Prompt",
    "message.views.activityInventory.platformSkuName": "Platform Sku Name",
    "message.views.inventoryReconciliation.changeTypeMap.totalFound": "Found",
    "message.lzdInboundDetail.title.sellerAddress": "Seller Address",
    "message.lzdInboundCreateView.tableColumn.sellerDetail": "Seller Detail",
    "message.views.scItemView.shop": "Shop",
    "message.aegOutboundOrderDetail.title.logisticLogs": "Logistic Log",
    "message.outboundView.title.warehouseList": "Warehouse",
    "message.views.productView.mainShop": "Main Shop",
    "message.transform.inventoryBind": "Inventory Bind",
    "message.lzdInboundCreateView.addSkuView.queryView.fulfilmentSku": "Fulfilment Sku",
    "message.views.workbench.yoy": "YOY",
    "message.aegOutboundOrderDetail.logisticColumns.fulfillStatus": "Fulfil Status",
    "message.views.dashboardScore.dashboardName.all_order_quantity": "Total Order Quantity",
    "message.button.cancel": "Cancel",
    "message.message.fulfillment.chooseOneOrder": "Choose at least one order for shipment!",
    "message.views.dashboardScore.dashboardName.inventory_turn_over": "Inventory Turn Over",
    "message.card.fulfillment.tradeCreateTime": "Trade Create Time",
    "message.table.fulfillment.orderItemStatus": "Order Item Status Code",
    "message.aegOutboundOrderDetail.title.outboundTime": "Outbound Time",
    "message.outboundView.title.platform": "Platform",
    "message.CreateTransferOrder.skuView.fulfillmentSku": "Fulfillment SKU",
    "message.lzdInboundDetail.title.orderStatus": "Status",
    "message.card.fulfillment.buyerName": "Buyer Name",
    "message.transform.bindFailed": "Inventory Binding Failed",
    "message.table.fulfillment.actualItemPaidFee": "Actual Item Paid Fee",
    "message.drawer.fulfillment.shippingType": "Shipping Type",
    "message.views.workbench.noReplenishment": "No Replenishment Plan",
    "message.views.scItemView.sellerSku": "Seller Sku",
    "message.aegOutboundOrderDetail.consignColumn.gmtCreateStr": "Created Time",
    "message.CreateTransferOrder.deleteBtn": "delete",
    "message.views.scItemView.scItemMerchant": "FulfillmentSku Merchant",
    "message.card.fulfillment.orderInformation": "Order Information",
    "message.transform.shopBinding": "Store Binding",
    "message.views.feedback.feedbackContent": "FeedbackContent",
    "message.card.fulfillment.fulfillmentOrderId": "Fulfillment Order Id",
    "message.views.scItemView.length": "Length",
    "message.views.productView.operation": "Operation",
    "message.card.fulfillment.trackingNumber": "Tracking Number",
    "message.views.workbench.orderTime": "Order Time",
    "message.form.fulfillment.orderStatus": "Order Status",
    "message.views.workbench.dailyGmv": "Daily Gmv",
    "message.aegOutboundOrderDetail.consignColumn.gmtConfirmReceiveStr": "Confirm Received Time",
    "message.views.feedback.feedbackOptions.questionFeedback": "Question Feedback",
    "message.inboundView.table.orderStatus": "Status",
    "message.lzdInboundPlanView.queryForm.shopName": "Shop Name",
    "message.lzdInboundPlanView.replenishColumns.scItemName": "Fulfilment SKU Name",
    "message.views.publishTemplateView.merchant": "Merchant",
    "message.inboundView.table.inboundOrder": "Inbound No.",
    "message.menu.taskCenterItem": "Download Center",
    "message.transform.firstStep": "First Step",
    "message.lzdOutboundViewDetail.title.estimateTimeStr": "Estimated Time",
    "message.outboundView.table.orderStatus": "Order Status",
    "message.lzdInboundDetail.title.sellerInformation": "Seller Information",
    "message.views.dashboardScore.dashboardName.to_supplement": "To Supplement",
    "message.views.scItemView.updateScItemButton": "Update Submit",
    "message.views.workbench.channelSales": "Channel Gmv",
    "message.CreateTransferOrder.transferQuantity": "Plan Transfer Quantity",
    "message.views.scItemView.itemId": "ProductID",
    "message.menu.item": "Product/Goods",
    "message.views.workbench.quantity": "Quantity",
    "message.aegInboundDetail.title.basicInformation": "Basic Information",
    "message.card.fulfillment.receiverInfomation": "Receiver Information",
    "message.views.workbench.deliver": "Deliver",
    "message.views.workbench.today": "Today",
    "message.menu.activityInventory": "Activity Inventory",
    "message.views.liveInventory.platform": "Platform",
    "message.aegOutboundOrderDetail.title.skus": "Sku",
    "message.views.publishTemplateView.templateDetail": "Template Detail",
    "message.inboundView.title.shopName": "Shop",
    "message.table.fulfillment.trackingNumbers": "Tracking Numbers",
    "message.login.user_profile": "User Profile",
    "message.views.scItemView.shelfLifeManagement": "Shelf Life Management",
    "message.common.reset": "Reset",
    "message.aegOutboundOrderDetail.consignColumn.purchaseOrderNo": "Outbound No.",
    "message.views.publishTemplateView.deleteTemplate": "Delete Template",
    "message.transform.startTime": "Start Time",
    "message.lzdInboundCreateView.addSkuView.scItemName": "Item Name",
    "message.views.inventoryLedger.orderTypeMap.ADJUST_OUT": "Adjust out",
    "message.aegOutboundOrderDetail.title.basicInformation": "Basic Information",
    "message.outboundView.table.planQuantity": "Plan Quantity",
    "message.views.workbench.currentQuantity": "Current Quantity",
    "message.outboundView.table.merchantName": "Merchant Name",
    "message.inboundView.title.inboundOrder": "Inbound order No.",
    "message.outboundView.table.outboundTime": "Outbound Time",
    "message.views.publishTemplateView.addTemplate": "Add Template",
    "message.table.fulfillment.cod": "cod",
    "message.menu.createTransferOrder": "Create Transfer Order",
    "message.aegOutboundOrderDetail.title.totalQtyDec": "Quantity",
    "message.table.fulfillment.cbOrderStatusDesc": "CB Order Status",
    "message.inboundView.table.merchantName": "Merchant Name",
    "message.aegOutboundOrderDetail.consignColumn.operate": "Operate",
    "message.views.workbench.inbound": "Inbound",
    "message.views.inventoryLedger.orderTypeMap.TRADE_OUT": "Fulfillment Outbound",
    "message.aegInboundDetail.purchaseItemColumn.quantityDec": "Purchase Quantity",
    "message.CreateTransferOrder.skus": "SKU Info",
    "message.aegInboundDetail.title.cancelReason": "Cancelled Reason",
    "message.taskCenterView.table.taskStatus": "Task Status",
    "message.aegOutboundOrderDetail.title.creator": "Creator",
    "message.table.fulfillment.totalItemFee": "Total Item Fee",
    "message.lzdOutboundViewDetail.title.deliverTypeName": "Deliver Type Name",
    "message.CreateTransferOrder.entityCode": "Source Warehouse",
    "message.CreateTransferOrder.destFulfillmentSKU": "Dest Fulfillment SKU",
    "message.views.inventoryLedger.orderTypeMap.IMBALANCE_LOCK": "Warehouse lock",
    "message.views.inventoryLedger.orderTypeMap.REFOUND_IN": "Fulfillment Reverse Inbound",
    "message.views.inventoryLedger.orderTypeMap.OTHER": "OTHER",
    "message.views.activityInventory.fulfillmentSkuCode": "Fulfillment Sku Code",
    "message.views.inventoryAging.averageAge": "Average Age",
    "message.views.feedback.feedbackOptions.systemBug": "System Bug",
    "message.views.inventoryAging.1-30day": "1-30 Day",
    "message.aegInboundDetail.title.actualArrivalTime": "Actual Arrival Time",
    "message.transform.authList": "Authorization List",
    "message.views.liveInventory.warehouse": "Warehouse",
    "message.views.liveInventory.onWayName": "On Way",
    "message.lzdOutboundViewDetail.title.sellerInformation": "Seller Information",
    "message.common.fulfillment.deliveryConfirm": "delivery confirm",
    "message.inboundView.title.warehouseList": "Inbound Warehouse",
    "message.views.productPublishView.templateDetail": "Template Detail",
    "message.aegInboundDetail.goodsTable.title": "Seller SKU",
    "message.transform.shopBindFailedAndDownload": "Store Binding Failed, Download Failure Details",
    "message.select.fulfillment.completeShipping": "Ship All",
    "message.common.commit": "commit",
    "message.views.workbench.dashboardDescription.channelProductSold": "Bar chart of product sold from different channels in the last week",
    "message.outboundView.table.detail": "Detail",
    "message.lzdOutboundViewDetail.title.orderStatusName": "Status",
    "message.views.activityInventory.occupyQuantity": "Occupy Quantity ",
    "message.menu.productPublishView": "Product Publish",
    "message.inboundView.button.reset": "Reset",
    "message.inboundView.title.createTime": "Created Time",
    "message.transform.ae.description": "AE Store Binding Entrance",
    "message.transform.bindException": "Inventory Binding Exception",
    "message.TransferOrder.search": "Search",
    "message.aegInboundDetail.logisticColumns.operateTime": "Operation time",
    "message.transform.inventoryCheck": "Inventory Check",
    "message.CreateTransferOrder.skuView.add": "add",
    "message.transform.finished": "Finished",
    "message.views.stockAllocation.stockAllocation": "Adjust Stock",
    "message.views.dashboardScore.dashboardName.to_inbound": "To Inbound",
    "message.table.fulfillment.receiverZip": "Receiver Zip",
    "message.login.task_center": "task center",
    "message.TransferOrder.createTime": "Created Time",
    "message.aegOutboundOrderDetail.title.totalReturnQuantity": "Return Quantity",
    "message.views.dashboardScore.table.rate": "Rate",
    "message.lzdInboundPlanView.replenishColumns.replOrderNo": "ReplOrder No.",
    "message.TransferOrder.outboundWarehouse": "Outbound Warehouse",
    "message.menu.feedback.feedback": "Feedback",
    "message.inboundView.table.warehouse": "Warehouse",
    "message.views.scItemView.addRelatedPlatformSku": "Relate PlatformSku",
    "message.views.stockAllocation.platformSkuCode": "Platform Sku Code",
    "message.form.fulfillment.tradeCreateTime": "Create Time",
    "message.table.fulfillment.buyerName": "Buyer Name",
    "message.lzdInboundDetail.title.ioType": "Io Type",
    "message.lzdInboundDetail.lzdItemTable.sellerSku": "Seller Sku",
    "message.inboundView.alert.shop": "Shop Selected",
    "message.views.liveInventory.onWay.transferOnWay": "Transfer OnWay",
    "message.views.stockAllocation.platformSkuName": "Platform Sku Name",
    "message.table.fulfillment.tradeCreateTime": "Trade Create Time",
    "message.views.publishTemplateView.gmtModified": "Modify Time",
    "message.menu.fulfillment": "Fulfillment",
    "message.inboundView.table.merchantCode": "Merchant Code",
    "message.views.productView.merchant": "Merchant",
    "message.views.scItemView.basicInfo": "Basic Info",
    "message.table.fulfillment.quantity": "Quantity",
    "message.TransferOrder.operate": "Operate",
    "message.inboundView.table.platform": "Platform",
    "message.views.workbench.channelOrderQuantity": "Channel Order Quantity",
    "message.views.stockAllocation.save": "save",
    "message.transform.upStep": "Previous",
    "message.inboundView.table.operate": "Operate",
    "message.TransferOrder.pleaseSelect": "Please select",
    "message.card.fulfillment.tradeOrderId": "Trade Order Id",
    "message.aegInboundDetail.title.remart": "Remart",
    "message.views.scItemView.barcode": "Barcodes",
    "message.table.fulfillment.receiverName": "Receiver Name",
    "message.menu.publishTemplateView": "Template",
    "message.card.fulfillment.receiverZip": "Receiver Zip",
    "message.menu.fulfillmentOrder": "Order",
    "message.message.fulfillment.batchShippingMessage": "You can only select orders from one merchant at a time for shipment!",
    "message.outboundView.title.outboundOrderNo": "Outbound No.",
    "message.lzdOutboundViewDetail.title.mobile": "Mobile",
    "message.table.fulfillment.cbFulfillmentOrderItemId": "CB Fulfillment Order Item Id",
    "message.login.switch_to_th_th": "เปลี่ยนเป็นภาษาไทย",
    "message.views.scItemView.itemSite": "Product Site",
    "message.aegOutboundOrderDetail.title.skuVariety": "Sku",
    "message.views.productPublishView.inputSearchText": "input the search text",
    "message.views.dashboardScore.table.operation": "Operation",
    "message.views.inventoryAging.inventoryType": "Inventory Type",
    "message.lzdInboundCreateView.tableColumn.submitBtn": "Submit",
    "message.transform.transferred": "Transferred",
    "message.button.print": "Print",
    "message.views.publishTemplateView.longDesc": "Long Description",
    "message.views.scItemView.merchant": "Merchant",
    "message.table.fulfillment.skuId": "Sku Id",
    "message.outboundView.table.creator": "Creator",
    "message.aegOutboundOrderDetail.title.inventoryType": "Inventory Type",
    "message.aegInboundDetail.title.skus": "SKUS",
    "message.views.productPublishView.publishTemplate": "Publish Template",
    "message.card.fulfillment.tradeOrderItemId": "Trade Order Item Id",
    "message.lzdInboundCreateView.addSkuView.searchBtn": "Search",
    "message.lzdOutboundViewDetail.title.ioTypeName": "Io Type",
    "message.aegOutboundOrderDetail.purchaseItemColumn.title": "Title",
    "message.aegInboundDetail.logisticColumn.operator": "Operator",
    "message.views.stockAllocation.adjustStockSuccess": "Adjust Stock Success",
    "message.aegInboundDetail.goodsTable.scItemId": "Fulfilment SKU"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alife_mcms_crossborder-merchant-web_front_end@0.0.20@@alife/mcms_crossborder-merchant-web_front_end/en-us.js
// module id = fiHy
// module chunks = 16